import { Css, PageHeaderLayout } from "@homebound/beam";
import { TaskStatusesFragment } from "src/fragments/circularFragments.generated";
import { useRouteParams } from "src/hooks/useRouteParams";
import { DevelopmentBulkScheduleTable } from "src/routes/developments/schedule/components/DevelopmentBulkScheduleTable";
import {
  DevelopmentBulkScheduleDevelopmentDetailFragment,
  useDevelopmentBulkScheduleQuery,
} from "src/routes/developments/schedule/DevelopmentBulkSchedulePage.generated";
import { queryResult } from "src/utils";

export function DevelopmentBulkSchedulePage() {
  const { developmentId } = useRouteParams<{ developmentId: string }>();
  const query = useDevelopmentBulkScheduleQuery({ variables: { developmentId } });

  return queryResult(query, {
    data: ({ development, taskStatuses }) => (
      <DevelopmentBulkSchedulePageView
        development={development}
        taskStatuses={taskStatuses}
        refetchScheduleQuery={query.refetch}
      />
    ),
  });
}

type DevelopmentBulkSchedulePageViewProps = {
  development: DevelopmentBulkScheduleDevelopmentDetailFragment;
  taskStatuses: TaskStatusesFragment[];
  refetchScheduleQuery: ReturnType<typeof useDevelopmentBulkScheduleQuery>["refetch"];
};

function DevelopmentBulkSchedulePageView(props: DevelopmentBulkSchedulePageViewProps) {
  const { development, taskStatuses, refetchScheduleQuery } = props;
  const { name } = development;

  return (
    <PageHeaderLayout pageHeader={{ title: "Lot Schedules", documentTitleSuffix: name, rightSlot: <ScheduleLegend /> }}>
      <DevelopmentBulkScheduleTable
        development={development}
        taskStatuses={taskStatuses}
        refetchScheduleQuery={() => refetchScheduleQuery()}
      />
    </PageHeaderLayout>
  );
}

function ScheduleLegend() {
  return (
    <div css={Css.df.fdc.gap1.$} data-testid="scheduleLegend">
      <span css={Css.df.aic.xs.$}>
        <span css={Css.df.w1.h1.br100.bgRed100.mr1.ba.bcGray600.$} /> Past incomplete task
      </span>
      <span css={Css.df.aic.xs.$}>
        <span css={Css.df.w1.h1.br100.bgYellow200.mr1.ba.bcGray600.$} /> Upcoming potential delay
      </span>
    </div>
  );
}

export const myProjectsId = "my-projects";
